import React from 'react';
import { makeStyles,Container,Paper,Typography,Box,Button} from '@material-ui/core';
import {useSelector,useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';

import versus from './versus-removebg-preview.jpg';


/* #21094E - dark purple
#511281 - purple
#4CA1A3 - green
#45E1AD - light green */
const useStyles=makeStyles({
    root:{
        minHeight:'100vh',
        background:'linear-gradient(to bottom right,rgba(33, 9, 78,0.6),#4CA1A3,rgba(81, 18, 129,0.6),#45E1AD)',
        display: 'flex',
        justifyContent:'center',
        alignItems:'center'
    },
    paper:{
        width:'400px',
        height:'400px',
        borderRadius:'10px',
        overflow: 'hidden',
        position:'relative'
    },
    one:{
        width:'85%',
        height:'55%',
        background:'linear-gradient(to right bottom,#4CA1A3,#45E1AD)',
        position: 'absolute',
        borderRadius:'50%',
        opacity: '0.6',
        top:'-35%',
        left: '-4%'
    },
    two:{
        background:'linear-gradient(to right bottom,#4CA1A3,#45E1AD)',
        position: 'absolute',
        opacity: '0.6',
        height:'40%',
        top:'-15%',
        left:'-5%',
        width :'45%',
        borderRadius:'50%'
    },
    three:{
        background:'linear-gradient(to right bottom,#4CA1A3,#45E1AD)',
        position: 'absolute',
        opacity: '0.6',
        height:'27%',
        top:'-10%',
        right:'-15%',
        width :'85%',
        borderRadius:'50%'
    },
    teamBox:{
        position: 'absolute',
        padding:'0 10px',
        overflow: 'hidden',
        right:0,
        left:0,
        bottom:0,
        height:'65%'
    },
    button:{
        width:'100%',
        margin:'0 auto',
        background:'#45E1AD',
        position:'absolute',
        bottom:0,
        left:0,
        right:0,
        "&:hover":{
            background:'#511281',
            color:'#fff'
        }
    },
    teamInnerBox:{
        display:"flex",
        marginBottom:'20px',
        padding:'0 10px'
    }
})

const Card = () => {
    const classes=useStyles();
    const history=useHistory();
    const match=useSelector((state)=>state.selectedMatch);

    const clickHandle=()=>{
        history.push("/scoreBoard")
    }

    if(!match){
        return <h1>Loading...</h1>
    }
    return (
        <div>
            <Container maxWidth="lg" className={classes.root}>
                <Paper className={classes.paper} elevation={5}>
                   <div className={classes.one}></div>
                   <div className={classes.two}></div>
                   <div className={classes.three}></div>
                  <Box component="div" className={classes.teamBox}>
                 <Box className={classes.teamInnerBox}>
                 <Typography variant="h5" align="center">{match.info.teams[0]}</Typography>
                  <img src={versus} height="100px" alt="versus"/>
                  <Typography variant="h5" align="center" >{match.info.teams[1]}</Typography>
                 </Box>
                  <Typography variant="body1" gutterBottom>At {match.info.venue},{match.info.city}.</Typography>
                  <Typography variant="body1">{`${match.info.toss.winner} has won the toss and decided to ${match.info.toss.decision} .`}</Typography>
                  <Button variant="contained" onClick={clickHandle} className={classes.button}>Continue</Button>
                  </Box>
                </Paper>
            </Container>
        </div>
    )
}

export default Card
